import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectWarehouseInStore, selectWarehousePageLoading, selectWarehouseShowInitWaitingMessage } from '../_selectors/warehouse.selectors';

export class WarehouseDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectWarehousePageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectWarehouseShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectWarehouseInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
